import { Component, Injector, OnInit } from '@angular/core';
import { BaseClass } from '../../utility/baseClass';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { VALIDATION_PATTERNS } from '../../utility/validation-patterns';
import { Utilityservice } from '../../utility/utilityservice.service';
import { CurrencyService } from '../../main-layout/currency/currency.service';
import { erase, error } from 'highcharts';
@Component({
  selector: 'app-currencymodal',
  templateUrl: './currencymodal.component.html',
  styleUrls: ['./currencymodal.component.css']
})
export class CurrencymodalComponent extends BaseClass implements OnInit {

  currencyForm: FormGroup
  onlyView: any;
  message: Messages = new Messages();
  tempcategory: any;
  tempcategoryupdate: any;
  saveTitle = 'Add'
  CSRFToken = "";
  isEdit: boolean = false;
  ct_currencyid = null
  activestatus = [
    {
      'labelname': 'Yes',
      'value': 'Y'
    },
    {
      'labelname': 'No',
      'value': 'N'
    }
  ];
  CategoryDetails: any = {}
  exceldownloadModal = false
  showDialog() {
    this.exceldownloadModal = true

  }

  public validation_message = {
    name: [
      { type: 'required', message: 'Currency Name is required' },
      { type: 'SPACERISTRICT', message: 'Space is not allowed at the beginning or end' },
      { type: 'NOTALLOW_SPECIAL_CHAR', message: 'Special characters are not allowed ( % and \' ).' },
      { type: 'maxlength', message: 'Maximum length exceeded' },
      { type: 'ONLYNUMERIC_NOTALLOW', message: 'Only numeric not allowed' }
    ],
    defaultflag: [
      { type: 'required', message: 'Default Flag Name is required' },
    ]
  }
  constructor(
    private currencyService: CurrencyService,
    private formBuilder: FormBuilder,
    public router: Router,
    public override  injector: Injector,
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utilityserv: Utilityservice,

  ) {
    super(injector);
    const dataFromParent = this.config.data;

    if (dataFromParent?.title == 'Modify currency') {
      this.saveTitle = 'Modify'
      this.isEdit = true;
      this.CategoryDetails = dataFromParent.datas
    }
  }

  ngOnInit() {
    this.formInitiliaze();
    this.getData();
    this.gettoken();
  }

  getData() {
    if (this.CategoryDetails.length !== undefined) {
      this.patchValueForms(this.CategoryDetails)
    }
  }


  patchValueForms(data) {
    this.ct_currencyid = data[0].ct_currencyid;
    this.currencyForm.patchValue({ 'name': data[0].ct_currencyname });
    this.currencyForm.patchValue({ 'defaultflag': data[0].defaultflag });
  }

  formInitiliaze() {
    this.currencyForm = this.formBuilder.group({
      name: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(100),
        Validators.pattern(VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR),
        Validators.pattern(VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW),
        Validators.pattern(VALIDATION_PATTERNS.SPACERISTRICT),
      ])],
      defaultflag: ['', Validators.required,]
    })
  }


  addCurrency() {
    if (this.currencyForm.invalid) {
      this.validateAllFormFields(this.currencyForm);
    }
    else {
      const payload = {
        name: this.currencyForm.get('name').value,
        defaultflag: this.currencyForm.get('defaultflag').value,
        csrftoken: this.CSRFToken,
      }
      if (this.saveTitle == 'Modify') {
        this.modifyCurrency(payload)
      }
      else {
        Swal.fire({
          title: "Do you want to save the changes?",
          showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: "Save",
          denyButtonText: `Don't Save`
        }).then((value) => {
          if (value.isConfirmed) {
            this.currencyService.createCurrency(payload).subscribe((data) => {
              this.tempcategory = data;
              if (this.tempcategory.response == 'exists') {
                Swal.fire("Currency already exists!", "", "error").then(result => {
                  //this.ref.close()
                });
              }
              else if (this.tempcategory.response == 'default') {
                Swal.fire("Default currency is already mapped for this organization.", "", "error").then(result => {
                  //this.ref.close()
                })
              }
              else {
                Swal.fire("Currency added successfully!", "", "success").then(result => {
                  this.ref.close()
                });
              }
            });
          } else if (value.isDenied) {
            Swal.fire("Changes are not saved!", "", "info")
            this.ref.close()
          }
        }, error=>{
            if (error.error.response == 'html') {
                Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                })
              }       
             });
      }
    }
  }
 

  modifyCurrency(data: any) {
    data['ct_currencyid'] = this.CategoryDetails[0].ct_currencyid;
    this.currencyForm.value
    if (this.currencyForm.invalid) {
      this.validateAllFormFields(this.currencyForm);
    }
    else {
      Swal.fire({
        title: "Do you want to save the changes?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Save",
        denyButtonText: `Don't Save`
      })
      .then((value) => {
        if (value.isConfirmed) {
          this.currencyService.modifyCurrencyData(data).subscribe((data) => {
            this.tempcategoryupdate = (data);
            console.log(data);
            if (this.tempcategoryupdate.response == 'exists') {
              Swal.fire("Currency already exists!", "", "error").then(result => {
                //this.ref.close()
              });
            }
            else if (this.tempcategoryupdate.response == 'default') {
              Swal.fire("Default currency is already mapped for this organization.", "", "error").then(result => {
                //this.ref.close()
              });
            }
            else {
              Swal.fire("Currency modified successfully!", "", "success").then(result => {
                this.ref.close()
              });
            }
          }, error=>{
            if (error.error.response == 'html') {
                Swal.fire("The data you entered contains HTML or JavaScript code, which is not allowed. Please remove the HTML or JavaScript content and try again.", "", "error").then(result => {
                })
              }       
             });
        } else if (value.isDenied) {
          Swal.fire("Changes are not saved!", "", "info")
          this.ref.close()
        }
      });
    }
  }

  gettoken() {
    this.CSRFToken = '';
    this.utilityserv.getCSRFtoken().subscribe(res => {
      this.CSRFToken = res.csrf;
    })
  }

}

export class Messages {
  name: string;
  customerpattern: string;
}
